import { Trade, Trades } from "@/library/Types";
import { ActionTree } from "vuex";
import http from "@/library/http";
import { RootState } from "./";
import { format, parse } from "date-fns";

export type State = {
  trades: Trades[];
  selectedIndex: number;
  type: string;
};

const state: State = {
  trades: [],
  selectedIndex: 0,
  type: "monthly",
};

const mutations = {
  setTrades: (state: State, trades: Trades[]): void => {
    state.trades = trades;
  },
  setSelectedIndex: (state: State, index: number): void => {
    state.selectedIndex = index;
  },
  setType: (state: State, type: string): void => {
    state.type = type;
  },
};

const actions: ActionTree<State, RootState> = {
  getTrades: async ({ state, commit }): Promise<any> => {
    return new Promise((resolve, reject) => {
      http
        .get(`/trades/${state.type}`)
        .then((response) => {
          commit("setTrades", response.data);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};

const selectedTrades = (state: State): Trade[] => {
  return state.trades.length > 0 ? state.trades[state.selectedIndex].trades : [];
};

const chartData = (state: State): Array<Record<string, any>> => {
  return selectedTrades(state).map((t) => {
    const color = t.profit >= 0 ? "#4ac450" : "#d65076";
    if (state.type == "weekly") {
      const { start_date, end_date, profit, profit_percent } = t;
      return {
        value: t.profit,
        start_date,
        end_date,
        profit,
        profit_percent,
        itemStyle: {
          color,
          //emphasis: { shadowColor: "rgba(0, 0, 0, 0.7)", shadowBlur: 10 },
        },
      };
    } else {
      const { profit, year, month } = t;
      return {
        value: t.profit,
        year,
        month,
        profit,
        itemStyle: {
          color,
        },
      };
    }
  });
};

const xAxis = (state: State): Array<string> => {
  const labels = [];
  const numLabels = state.type == "weekly" ? 13 : 12;
  for (let i = 1; i <= numLabels; i++) {
    labels.push("");
  }
  return labels;
};

const tooltipFormatterWeekly = (params: Record<string, any>): string => {
  const trade = params.data;
  const startDate = parse(trade.start_date, "yyyy-MM-dd", new Date());
  const endDate = parse(trade.end_date, "yyyy-MM-dd", new Date());
  //return `${format(startDate, "M/d/yy")} - ${format(endDate, "M/d/yy")}<br>$${trade.profit}<br>${trade.profit_percent}%`;
  return `${format(startDate, "M/d/yy")} - ${format(endDate, "M/d/yy")}<br>$${trade.profit}`;
};

const tooltipFormatterMonthly = (params: Record<string, any>): string => {
  const trade = params.data;
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${trade.year} ${monthNames[trade.month - 1]}<br>$${trade.profit}`;
};

const options = (state: State): Record<string, any> => {
  return {
    grid: { top: 0, bottom: 10, left: 10, right: 10, containLabel: false },
    xAxis: { data: xAxis(state) },
    yAxis: { show: false },
    tooltip: {
      formatter: (params: Record<string, any>) => {
        return state.type == "weekly" ? tooltipFormatterWeekly(params) : tooltipFormatterMonthly(params);
      },
    },
    series: [{ type: "bar", data: chartData(state) }],
  };
};

const getters = {
  options,
  selectedTrades,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
